module.exports = __webpack_public_path__ + "img/store.29ee397b.png";